import React from 'react';
import './Acoustics.css';
import Timeline from '../Timeline/Timeline';
import StageCanvas, { StageCanvasMode } from '../StageCanvas/StageCanvas';
import Slider from './Slider';
import { AcousticSettingsPreset, getAcousticSettingsPresetDisplayName } from '../../models/AcousticSettings';
import useTypedSelector from '../../hooks/use-type-selectors';
import useActions from '../../hooks/use-actions';

const Acoustics: React.FC = () => {
	const { setCustomAcousticSettings, setAcousticSettingsPreset } = useActions();
	const acousticSettings = useTypedSelector(state => state.undoable.acousticSettings);

	function setPreset () {
		var presetSelected = ((document.getElementById("acousticPresetSelect")) as HTMLSelectElement).selectedIndex;
		setAcousticSettingsPreset(presetSelected);
	}

	function updateDecayTime (newDecayTime: number) {
        setCustomAcousticSettings({
			...acousticSettings.reverbSettings,
			decayTime: newDecayTime
		});
    }

	function updateDensity (newDensity: number) {
        setCustomAcousticSettings({
			...acousticSettings.reverbSettings,
			density: newDensity
		});
    }

	function updateDryGain (newDryGain: number) {
        setCustomAcousticSettings({
			...acousticSettings.reverbSettings,
			dryGain: newDryGain
		});
    }

	function updateEarlyDecay (newEarlyDecay: number) {
        setCustomAcousticSettings({
			...acousticSettings.reverbSettings,
			earlyDelay: newEarlyDecay
		});
    }

	function updateHFCutoff (newHFCutoff: number) {
        setCustomAcousticSettings({
			...acousticSettings.reverbSettings,
			hfCutoff: newHFCutoff
		});
    }

	function updateHFDecay (newHFDecay: number) {
        setCustomAcousticSettings({
			...acousticSettings.reverbSettings,
			hfDecay: newHFDecay
		});
    }

	function updateLateDelay (newLateDelay: number) {
        setCustomAcousticSettings({
			...acousticSettings.reverbSettings,
			lateDelay: newLateDelay
		});
    }

	function updateWetGain (newWetGain: number) {
        setCustomAcousticSettings({
			...acousticSettings.reverbSettings,
			wetGain: newWetGain
		});
    }

	return (
		<div className='gridContainer'>
			<div className='sideBar' style={{ overflow: 'auto' }}>
				<div style={{ display: 'flex', alignItems:'center', marginBottom: '20px' }}>
					<img className='acousticsIcon' alt='Acoustics' aria-hidden />
					<h1 style={{ margin: 0 }}>ACOUSTICS</h1>
				</div>
				<select
					id='acousticPresetSelect'
					aria-label='acoustic theme is'
					className='dropdown'
					value={acousticSettings.preset}
					onChange={setPreset}>
						{Object.keys(AcousticSettingsPreset).filter(preset => isNaN(Number(preset))).map((preset, index) => 
                            <option value={index}>{getAcousticSettingsPresetDisplayName(index)}</option>
                        )}
				</select>
				<hr className='divider' aria-hidden />
				<h2>Edit variables</h2>
				<Slider name='Dry Gain' min={0} max={1} step={0.01} value={acousticSettings.reverbSettings.dryGain} onChangeFunc={updateDryGain} />
				<Slider name='Wet Gain' min={0} max={1} step={0.01} value={acousticSettings.reverbSettings.wetGain} onChangeFunc={updateWetGain} />
				<Slider name='Early Delay' min={0} max={0.3} step={0.01} value={acousticSettings.reverbSettings.earlyDelay} onChangeFunc={updateEarlyDecay} />
				<Slider name='Density' min={0} max={20} step={0.1} value={acousticSettings.reverbSettings.density} onChangeFunc={updateDensity} />
				<Slider name='Late Delay' min={0} max={0.5} step={0.01} value={acousticSettings.reverbSettings.lateDelay} onChangeFunc={updateLateDelay} />
				<Slider name='Decay Time' min={0} max={5} step={0.1} value={acousticSettings.reverbSettings.decayTime} onChangeFunc={updateDecayTime} />
				<Slider name='High Frequency Cutoff' min={0} max={20000} step={100} value={acousticSettings.reverbSettings.hfCutoff} onChangeFunc={updateHFCutoff} />
				<Slider name='High Frequency Decay' min={0} max={1} step={0.01} value={acousticSettings.reverbSettings.hfDecay} onChangeFunc={updateHFDecay} />
			</div>
			<div className='stage'>
				<StageCanvas mode={StageCanvasMode.ViewOnly} />
			</div>
			<div className='timeline'>
				<Timeline />
			</div>
		</div>
	);
};

export default Acoustics;
